import { useState, useEffect } from 'react';
import { adminListOrgs } from '../api';
import { setOrgId } from '../auth';

export default function SuperAdmin({ onImpersonate, onClose }) {
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');

  useEffect(() => {
    adminListOrgs()
      .then(setOrgs)
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  const filtered = orgs.filter(o =>
    o.name.toLowerCase().includes(search.toLowerCase())
  );

  const totalPlayers  = orgs.reduce((s, o) => s + (o.playerCount || 0), 0);
  const totalMembers  = orgs.reduce((s, o) => s + (o.memberCount || 0), 0);
  const totalProjects = orgs.reduce((s, o) => s + (o.projectCount || 0), 0);
  const planCounts    = orgs.reduce((acc, o) => { acc[o.plan] = (acc[o.plan] || 0) + 1; return acc; }, {});

  const planBadge = (plan) => {
    const styles = {
      free:  { background: '#f3f4f6', color: '#374151' },
      pro:   { background: '#dbeafe', color: '#1e40af' },
      enterprise: { background: '#fef3c7', color: '#92400e' },
    };
    const s = styles[plan] || styles.free;
    return <span style={{ ...s, padding: '2px 10px', borderRadius: 20, fontSize: 12, fontWeight: 700 }}>{plan}</span>;
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0f1f3d' }}>
      {/* Header */}
      <div style={{ background: '#0f1f3d', borderBottom: '1px solid rgba(255,255,255,0.1)', padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ fontSize: 22, fontWeight: 800, color: 'white' }}>💰 DuesTrack</span>
          <span style={{ background: '#c0392b', color: 'white', fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 20, letterSpacing: '0.5px' }}>SUPER ADMIN</span>
        </div>
        <button className="nav-btn" onClick={onClose} style={{ background: 'rgba(255,255,255,0.1)', color: 'white', border: 'none', padding: '7px 16px', borderRadius: 6, cursor: 'pointer', fontWeight: 600 }}>
          ← Back to My Org
        </button>
      </div>

      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '32px 24px' }}>

        {/* Platform Stats */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 16, marginBottom: 32 }}>
          {[
            { label: 'Total Organizations', value: orgs.length, color: '#7dd3fc' },
            { label: 'Total Managers', value: totalMembers, color: '#86efac' },
            { label: 'Total Projects', value: totalProjects, color: '#fcd34d' },
            { label: 'Total Players', value: totalPlayers, color: '#f9a8d4' },
            { label: 'Free Plans', value: planCounts.free || 0, color: '#d1d5db' },
            { label: 'Pro Plans', value: planCounts.pro || 0, color: '#93c5fd' },
          ].map(s => (
            <div key={s.label} style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: '16px 20px' }}>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 6 }}>{s.label}</div>
              <div style={{ fontSize: 32, fontWeight: 900, color: s.color }}>{s.value}</div>
            </div>
          ))}
        </div>

        {/* Org Table */}
        <div style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 12, overflow: 'hidden' }}>
          <div style={{ padding: '16px 20px', borderBottom: '1px solid rgba(255,255,255,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ color: 'white', fontWeight: 700, fontSize: 16 }}>
              All Organizations <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: 14, fontWeight: 400 }}>({filtered.length})</span>
            </div>
            <input
              value={search} onChange={e => setSearch(e.target.value)}
              placeholder="Search orgs…"
              style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 7, padding: '7px 12px', color: 'white', fontSize: 14, width: 220 }}
            />
          </div>

          {error && <div style={{ padding: 20, color: '#fca5a5' }}>{error}</div>}

          {loading ? (
            <div style={{ padding: 40, textAlign: 'center', color: 'rgba(255,255,255,0.4)' }}>Loading…</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: 'rgba(255,255,255,0.04)' }}>
                  {['Organization', 'Plan', 'Managers', 'Projects', 'Players', 'Created', 'Actions'].map(h => (
                    <th key={h} style={{ padding: '10px 16px', textAlign: 'left', fontSize: 12, fontWeight: 700, color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map(org => (
                  <tr key={org.orgId} style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}
                    onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.04)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <td style={{ padding: '12px 16px' }}>
                      <div style={{ color: 'white', fontWeight: 700 }}>{org.name}</div>
                      {org.description && <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 12, marginTop: 2 }}>{org.description}</div>}
                      <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: 11, marginTop: 2, fontFamily: 'monospace' }}>{org.orgId.slice(0, 8)}…</div>
                    </td>
                    <td style={{ padding: '12px 16px' }}>{planBadge(org.plan)}</td>
                    <td style={{ padding: '12px 16px', color: '#86efac', fontWeight: 700 }}>{org.memberCount || 0}</td>
                    <td style={{ padding: '12px 16px', color: '#fcd34d', fontWeight: 700 }}>{org.projectCount || 0}</td>
                    <td style={{ padding: '12px 16px', color: '#f9a8d4', fontWeight: 700 }}>{org.playerCount || 0}</td>
                    <td style={{ padding: '12px 16px', color: 'rgba(255,255,255,0.4)', fontSize: 13 }}>
                      {new Date(org.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                    </td>
                    <td style={{ padding: '12px 16px' }}>
                      <button
                        onClick={() => { setOrgId(org.orgId); onImpersonate(org); }}
                        style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', color: 'white', padding: '5px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 600 }}
                        onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
                        onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}>
                        View Org →
                      </button>
                    </td>
                  </tr>
                ))}
                {filtered.length === 0 && (
                  <tr><td colSpan={7} style={{ padding: 40, textAlign: 'center', color: 'rgba(255,255,255,0.3)' }}>No organizations found</td></tr>
                )}
              </tbody>
            </table>
          )}
        </div>

        <div style={{ textAlign: 'center', marginTop: 24, color: 'rgba(255,255,255,0.2)', fontSize: 12 }}>
          DuesTrack Platform · Super Admin Console
        </div>
      </div>
    </div>
  );
}
